define([
    'core/iterate',
    'components/sidebar-flow',
    'core/urls',
    'core/utilities',
    'components/modal',
    "components/dropdown",
], function (
    iterate,
    sidebar,
    urls,
    utilities,
    modal,
    DD
){
    return {
        // pass isSurveyPage as True for survey pages where the selector is needed
        create: function(isSurveyPage) {
            let nodes = {
                wrap: document.querySelector(".sidebar_js"),
                closeSideBar: document.querySelectorAll(".close-sidebar_js"),
                menuSteps: document.querySelectorAll(".sidebar-menu-step_js"),
                contentSteps: document.querySelectorAll(".dns-sb-step_js"),
                sendDomainBtn: document.querySelector(".send-domain_js"),
                setUpDomainBtn: document.querySelector(".set-up-domain_js"),
                domainInput: document.querySelector(".domain-input_js"),
                domainMessage: document.querySelector(".dns-domain-message_js"),
                copyNodes: document.querySelectorAll(".sb-sidebar .copy-wrap"),
                copyText: document.querySelector(".copy_text_js"),
                tryAgainBtn: document.querySelector(".try_again_js"),
                verifyDNSBtn: document.querySelector(".verify_dns_js"),
                switchDomain: document.querySelector("[name='domain']"),
                exitSuccessSidebar: document.querySelector(".return-success_js"),
                errorNode:document.querySelector(".sb-sidebar__step-2-1 .verification-error"),
                form: {
                    fromAddress: document.querySelector("#from_address"),
                    fromAddressError: document.querySelector(".email-address.error"),
                    fromName: document.querySelector("#from_name"),
                    fromNameError: document.querySelector(".email-name.error"),
                    domain: document.querySelector("#id_domain"),
                },
                modal: {
                    modal: document.querySelector(".modal_js"),
                    close: document.querySelector(".modal-close_js"),
                    content: document.querySelector(".modal-content_js"),
                    title: document.querySelector(".modal-title_js"),
                    bg: document.querySelector(".modal-bg_js"),
                    blur: [
                        // document.querySelector(".nps-s1-setup-campaign"),
                        // document.querySelector(".navigation-main"),
                        // document.querySelector(".navigation-top")
                    ]
                },
            }
        
            let hrefs = document.querySelectorAll("a[href]");
            let closeSideBar = document.querySelector(".close-sidebar");
            let canClose = true;
            let domainName = "";
            let newDomainID = "";
            let domainSelector;
            let existingDomains;
            let domainData = "";
            let dnsSideBar = sidebar.create(nodes, null, (step, subStep)=>{});
        
            let createdModal = modal.create(nodes.modal, (el) => {});
            let exitModalTemplate = document.querySelector(".modal-template-leave_js");
        
            let closeModal = () => {
                dnsSideBar.switch(1, 2);
                dnsSideBar.close();
                removeExitDomainPrompt();
                    createdModal.close();
            };
        
            let toggleSendDomainBtn = (val) => {
                if (val)
                    nodes.sendDomainBtn.classList.remove("disabled");
                else
                    nodes.sendDomainBtn.classList.add("disabled");
            }
        
            let addDomain = async(domainName, cb) => {
                await fetch(`${urls["configuration:add-domain"]()}?domain=${domainName}`, {
                    method: "GET",
                })
                .then(response => {
                    if(response.status !== 200) {
                        cb(false);
                        nodes.sendDomainBtn.classList.remove("loading");
                        nodes.domainMessage.classList.add("active");
                        return null;
                    }
                    return response.json()
                })
                .then((json) => {
                    if(json) {
                        domainData = json;
                        newDomainID = json.id;
                        cb(json)
                    }
                });
            }

            let addToDomainManager = (validationSuccess) => {
                let domainWrapper = document.querySelector(".domains-wrapper");
                if(!domainWrapper) return;
                
                // if domain already exists on the page, update status and exit function
                let existingDomain = document.querySelector(`.domain.card[data-id="${domainData.id}"]`);
                if(existingDomain) {
                    let initialStatus = existingDomain.dataset.valid;

                    if(initialStatus !== validationSuccess) {
                        existingDomain.dataset.valid = validationSuccess;
                        existingDomain.querySelector(".status").classList.toggle("valid", validationSuccess);
                        existingDomain.querySelector(".status").innerText = validationSuccess ? "Valid" : "Invalid";
                    }

                    return;
                };

                // domain doens't exist, so create a new card
                let noDomainAlert = document.querySelector(".alert.no-domains");
                if(noDomainAlert) noDomainAlert.remove();

                let newDomain = `
                    <div class="domain card" data-id="${domainData.id}" data-name="${domainName}" data-valid=${validationSuccess}>
                        <div class="flex-wrapper card-head" data-id="${domainData.id}">
                            <div class="title">${domainName}</div>
                            <div class="status ${validationSuccess ? "valid" : ""}">
                                ${validationSuccess ? "Valid" : "Invalid"}
                            </div>
                            <div class="settings-toggle-wrap" data-id="${domainData.id}">
                                <img class="icon" src="/static/icons/settings-hover.svg" alt="">
                            </div>
                        </div>
                        <div class="settings custom-domains">
                            <div class="fieldset-wrap">
                                <fieldset class="spf">
                                    <legend>SPF Settings:</legend>
                                    <label for="spfName">Name:</label>
                                    <div class="input-wrap">
                                        <input type="text" readonly class="sb-input" data-spf-name="${domainData.spf.name}" id="spfName" value="${domainData.spf.name}">
                                        <div class="copy-wrap">
                                            Copy
                                        </div>
                                    </div>
                                    <label for="spfValue">Value:</label>
                                    <div class="input-wrap">
                                        <input type="text" readonly class="sb-input" data-spf-value="${domainData.spf.value}" id="spfValue" value="${domainData.spf.value}">
                                        <div class="copy-wrap">
                                            Copy
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset class="dkim">
                                    <legend>DKIM Settings:</legend>
                                    <label for="dkimName">Name:</label>
                                    <div class="input-wrap">
                                        <input type="text" readonly class="sb-input" id="dkimName" data-dkim-name="${domainData.dkim.name}" value="${domainData.dkim.name}">
                                        <div class="copy-wrap">
                                            Copy
                                        </div>
                                    </div>                                                
                                    <label for="dkimValue">Value:</label>
                                    <div class="input-wrap">
                                        <input type="text" readonly class="sb-input" id="dkimValue" data-dkim-value="${domainData.dkim.value}" value="${domainData.dkim.value}">
                                        <div class="copy-wrap">
                                            Copy
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div class="messaging hide"></div>
                            <div class="button-secondary validate" data-id="${domainData.id}">Re-validate</div>
                        </div>
                    </div>
                `

                // add card to list alphabetically
                let cardAdded = false;
                let allCards = domainWrapper.querySelectorAll(".card")
                if(allCards.length) {
                    allCards.forEach((card, i) => {
                        card.querySelector(".settings").classList.remove("active");
                        let cardName = card.dataset.name;      

                        if(cardName > domainName && !cardAdded) {
                            card.outerHTML = newDomain + card.outerHTML;
                            cardAdded = true;
                        }

                        if(i + 1 === allCards.length && !cardAdded) {
                            card.outerHTML = card.outerHTML + newDomain;
                            cardAdded = true;
                        }
                    })
                } else {
                    domainWrapper.innerHTML = domainWrapper.innerHTML + newDomain;
                }

                nodes.wrap.style.minHeight = `${document.querySelector(".canvas").offsetHeight}px`;
                
            }
        
            let validateDomain = async (cb) => {
                await fetch(urls["configuration:validate-domain"](newDomainID), {
                    method: "GET",
                })
                .then(response => {
                    if(response.status !== 200) {
                        cb(false);
                        return null;
                    }
                    return response.json()
                })
                .then((json) => {
                    if(json) {
                        cb(json)
                    }
                });
            }
        
            let leaveDomainListener = function(event)  {
                let message = "Exit ‘Set up your domain’?"
                utilities.confirmPageExit(event, createdModal, exitModalTemplate, message);
            };
        
            let onExitDomainFlow = () => {
                canClose = false;
                iterate(hrefs, (node) => {
                    node.addEventListener("click", leaveDomainListener);
                });
            }
        
            let removeExitDomainPrompt = () => {
                canClose = true;
                iterate(hrefs, (node) => {
                    node.removeEventListener("click", leaveDomainListener);
                });
            }
        
            let toggleDisabledFields = (disable, clearValues) => {
                if(disable) {
                    nodes.form.fromAddress.disabled = true;
                    nodes.form.fromName.disabled = true;
                    nodes.form.fromAddress.value = "noreply";
                    nodes.form.fromName.value = "SmileBack";
                    nodes.form.fromAddressError.classList.add("hide");
                    nodes.form.fromNameError.classList.add("hide");
                    nodes.form.fromAddress.classList.remove("error");
                    nodes.form.fromName.classList.remove("error");
                } else {
                    nodes.form.fromAddress.disabled = false;
                    nodes.form.fromName.disabled = false;
        
                    if(clearValues) {
                        nodes.form.fromAddress.value = "";
                        nodes.form.fromName.value = "";
                    }
                    
                }
            }
        
            nodes.verifyDNSBtn.addEventListener("click", (e) => {
                e.preventDefault();
                nodes.verifyDNSBtn.classList.add("loading");
                nodes.errorNode.classList.add("hide");

                validateDomain((resp) => {
                    if (resp.success) {
                        if(isSurveyPage) { // add domain to survey page and enable email fields
                            let isDuplicate = false;
                            existingDomains.querySelectorAll(".mock-option").forEach(domain => {
                                if(domain.innerText.trim() === domainName.trim()) {
                                    isDuplicate = true;
                                }
                            })
            
                            if(!isDuplicate) {
                                domainSelector.addOption(newDomainID, domainName);
                            } else {
                                domainSelector.chooseOption(newDomainID);
                            }

                            if(domainName.trim() === "smileback.io") {
                                toggleDisabledFields(true, false);
                            } else {
                                toggleDisabledFields(false, true);
                            }

                            nodes.domainInput.value = "";
                        }                        
                        dnsSideBar.switch(3, 1);
                    } else {
                        let errorMessage;

                        if(resp.errors && resp.errors.length > 0) {
                            errorMessage = `
                                Your domain is invalid due to the following issues: 
                                <ul>
                                    ${resp.errors.map(error => `<li>${error}</li>`).join('')}
                                </ul>
                                Please review your DNS settings. If you are unsure about the issue, you can use a webtool to perform an 
                                SPF record lookup (such as <a target="_blank" href="https://mxtoolbox.com/">https://mxtoolbox.com/</a>). This can help with diagnostics.                                
                            `
                        } else {
                            errorMessage = `
                                There is an issue with your domain settings. 
                                Please make sure your SPF TXT Record contains a SmileBack reference 
                                and your DKIM TXT Record matches above.
                            `
                        }
                        nodes.errorNode.innerHTML = `
                            ${errorMessage}
                            <br><br>
                            Please note: DNS verification is not always performed instantly. 
                            Please wait a few minutes to try again or you can get more information 
                            in our <a target="_blank" href="https://docs.connectwise.com/SmileBack/030/020/060">Help Center</a>.
                        `;

                        nodes.errorNode.classList.remove("hide");
                    }

                    if(!isSurveyPage) {
                        // add domain to domain manager page
                        addToDomainManager(resp.success);
                    }

                    nodes.verifyDNSBtn.classList.remove("loading");
                });
        
            });
        
            nodes.domainInput.addEventListener("input", (e) => {
                var val = e.target.value.trim();
                toggleSendDomainBtn(val);
            });
        
            nodes.tryAgainBtn.addEventListener("click", (e) => {
                nodes.errorNode.classList.add("hide");
                e.preventDefault();
                removeExitDomainPrompt();
                dnsSideBar.switch(1, 2);
            });
        
            nodes.exitSuccessSidebar.addEventListener("click", () => {
                removeExitDomainPrompt();
            });
        
            nodes.setUpDomainBtn.addEventListener("click", (e) => {
                e.preventDefault();
                dnsSideBar.switch(1, 2);
            });
        
            nodes.sendDomainBtn.addEventListener("click", (e) => {
                nodes.domainMessage.innerText = "Domain is Invalid.";
                nodes.sendDomainBtn.classList.add("loading");
                nodes.domainMessage.classList.remove("active");
        
                e.preventDefault();
        
                domainName = nodes.domainInput.value.trim();
        
                addDomain(domainName, (response) => {
                    nodes.sendDomainBtn.classList.remove("loading");
                    if (response && !response.error) {
                        if(!isSurveyPage) {
                            addToDomainManager(false);
                        }

                        // onExitDomainFlow();
                        dnsSideBar.switch(2, 1);

                        nodes.errorNode.classList.add("hide");

                        document.querySelector(".domain-name-context span").innerText = domainName;
        
                        iterate(response, (val, key) => {
                            if(key !== "id") {
                                iterate(val, (v, k) => {
                                    document
                                        .querySelector("[data-" + key + "-" + k + "]")
                                        .setAttribute("value", v);
                                })
                            }
                        });
        
                        nodes.copyNodes.forEach(button => {
                            button.addEventListener("click", () => {
                                let parent = button.parentElement;
                                let value = parent.querySelector("input").value;
                
                                navigator.clipboard.writeText(value).then(() => {
                                    button.innerText = "Copied!";
                                    button.classList.add("copied");
                
                                    setTimeout(() => {
                                        button.innerText = "Copy";
                                        button.classList.remove("copied");
                                    }, 3000)
                                });
                            })
                        })
        
                    } else if (response && response.error) {
                        let listClass = response.error.length > 1 ? "multiple-errors" : "";
                        nodes.domainMessage.innerHTML = `
                            <ul class="${listClass}">
                                ${response.error.map(error => `<li>${error}</li>`).join('')}
                            </ul>
                            Please review your DNS settings. If you are unsure about the issue, you can use a webtool to perform an 
                            SPF record lookup (such as <a target="_blank" href="https://mxtoolbox.com/">https://mxtoolbox.com/</a>). This can help with diagnostics.  
                        `
                        nodes.domainMessage.classList.add("active");
                    }
                })
            });
        
            closeSideBar.addEventListener("click", (e) => {
                e.preventDefault();
                if (canClose) {
                    dnsSideBar.switch(1, 2);
                    dnsSideBar.close();
                    nodes.domainInput.value = "";
                } else {
                    exitModalTemplate.querySelector(".confirm-msg_js b").innerText = "Exit ‘Set up your domain’?";
                    createdModal.open(null, (el) => {
                        const a = el.querySelector("a");
                        a.setAttribute("href", "#");
                        a.removeEventListener("click",closeModal);
                        a.addEventListener("click",closeModal);
                    }, exitModalTemplate);
                }
            });
        
            // initialize domain select dropdown
            if(isSurveyPage) {
                domainSelector = DD(
                    document.querySelector(".domain-selector"), 
                    // on select callback
                    (value) => {
                        if(value !== "-1") {
                            toggleDisabledFields(false, true);
                        } else {
                            toggleDisabledFields(true);
                        }
                    }, 
                    // onload callback
                    (target) => {
                    existingDomains = target.querySelector(".mock-options");
                    let domainLinkHTML = `
                        <div class="add-domain">Add new domain</div>
                    `;
            
                    existingDomains.insertAdjacentHTML("beforeend", domainLinkHTML);
            
                    let domainLink = existingDomains.querySelector(".add-domain");
                    domainLink.addEventListener("click", () => {
                        dnsSideBar.switch(1, 1, true);
                        // setUpStarted = true;
                        window.scrollTo(0, 0);
                        dnsSideBar.open();
                    })
            
                    toggleDisabledFields(target.querySelector("select").value === "-1" ? true : false, false);
                });
            } else {
                let domainLinks = document.querySelectorAll(".add-domain");
                domainLinks.forEach((domainLink) => {
                    domainLink.addEventListener("click", () => {
                        nodes.domainMessage.classList.remove("active");
                        dnsSideBar.switch(1, 2, true);
                        // setUpStarted = true;
                        window.scrollTo(0, 0);
                        dnsSideBar.open();
                    })
                })
                
            }
        }
    }
});
